var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons2ExportReminder10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 35.8C29 35.9 29 36 29 36C29 38.8 26.8 41 24 41C21.2 41 19 38.8 19 36C19 35.9 19 35.8 19 35.8",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11V10C27 8.3 25.7 7 24 7C22.3 7 21 8.3 21 10V11",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20C15 15 19 11 24 11C29 11 33 15 33 20V21.8C33 24.5 33.8 27.2 35.4 29.4L38 33C38 33 34.7 36 24 36C13.3 36 10 33 10 33L12.6 29.4C14.2 27.2 15 24.6 15 21.8V20Z",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons2ExportReminder10);
export default __webpack_public_path__ + "static/media/icons-2_export-REMINDER-10.d3be0c63465639d244f6c3845e741086.svg";
export { ForwardRef as ReactComponent };